const autoNgTemplateLoaderTemplate1 = require('./viewLoading.html');

angular.module('shbdeployer.kubernetes').component('kubernetesViewLoading', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    viewReady: '<',
  },
});
